import React, { Component } from 'react';
import { connect } from 'react-redux';
import {translate} from 'react-i18next';
import Spinner from '../components/Spinner/Spinner';

class SpinnerWaitLoadingData extends Component {


  render() {
    const {order, restaurants, t}  = this.props;
    const loading = restaurants.startFetch || order.get('startFetch');
    const message = restaurants.startFetch ? 'change_restaurants' : 'loading_data';
    return (
      <React.Fragment>
        {loading &&
          <div className='products__overlay-waiting-data'>
            <Spinner text={t(message)}/>
          </div>
        }
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    restaurants: state.restaurants,
    order: state.order,
  }
}

export default connect(mapStateToProps)(translate('translations')(SpinnerWaitLoadingData));


// WEBPACK FOOTER //
// ./src/containers/SpinnerWaitLoadingData.js